module.exports = __webpack_public_path__ + "static/img/date-bg.7d3d018d.png";